import { MetaTagsFieldsFragment } from 'types/generated';
import FacebookMetaTags from './FacebookMetaTags';
import TwitterMetaTags from './TwitterMetaTags';
import { getOr } from '@/utils/options';

type Props = {
  metaTags: MetaTagsFieldsFragment;
};

const MetaTags = (props: Props) => {
  const title = getOr(props.metaTags.title, 'Sýn');
  const description = getOr(props.metaTags.description, '');
  const url = getOr(props.metaTags.url, 'https://www.syn.is');
  const imageUrl = getOr(props.metaTags.image?.url, '');
  const keywords = getOr(props.metaTags.keywords, '');
  const socialMetaTags = { title, description, url, imageUrl };
  const robots = props.metaTags.noIndex;

  return (
    <>
      {robots && <meta name="robots" content="noindex, nofollow" />}
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="google-site-verification" content="2Z5bQP4HS0cP5CNl_ztZdgdb84DloJWZKjV1BjWZpTk" />
      <TwitterMetaTags {...socialMetaTags} />
      <FacebookMetaTags {...socialMetaTags} />
      {/* Weird bug: Have to add the OG tags 2x to be able to see 1x */}
      <FacebookMetaTags {...socialMetaTags} />
    </>
  );
};

export default MetaTags;
